import React from 'react';
import Layout from '../../components/Layout';
import { PageProps } from '../../App';
import { Link } from 'react-router-dom';

// Componente da página Lupa Paranoá com tipagem correta
const LupaParanoaPage: React.FC<PageProps> = ({ darkMode, toggleDarkMode }) => {
  return (
    <Layout darkMode={darkMode} toggleDarkMode={toggleDarkMode}>
      <div className="bg-white dark:bg-gray-900">
        {/* Hero Section */}
        <div className="relative bg-gradient-to-r from-lupa-orange to-lupa-yellow overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-r from-lupa-purple-dark/70 to-lupa-purple/30 z-10"></div>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 relative z-20">
            <div className="text-center">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight font-heading">
                Lupa Paranoá
              </h1>
              <p className="mt-6 text-xl text-white/90 max-w-3xl mx-auto">
                Transforme seus dados em decisões inteligentes com nossa plataforma completa de gestão e análise de dados.
              </p>
            </div>
          </div>
          <div className="absolute bottom-0 left-0 right-0">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" className="w-full h-auto">
              <path fill="#ffffff" fillOpacity="1" d="M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,122.7C672,117,768,139,864,149.3C960,160,1056,160,1152,138.7C1248,117,1344,75,1392,53.3L1440,32L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
            </svg>
          </div>
        </div>

        {/* Conteúdo Principal */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-lupa-purple dark:text-white mb-6">Entenda Seus Dados, Transforme Seu Negócio</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                O Lupa Paranoá é nossa solução completa para unificar, organizar e extrair valor dos seus dados. Desenvolvida para empresas de todos os tamanhos, nossa plataforma elimina a complexidade técnica e permite que você se concentre no que realmente importa: tomar decisões melhores com base em informações confiáveis.
              </p>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                <p className="mt-4 text-gray-700 dark:text-gray-300">
  Nossa principal diferença está no modelo de negócio: <span className="font-semibold text-lupa-orange">Dados como Serviço (DaaS)</span>. Além de abstrair toda a complexidade técnica, oferecemos um modelo de cobrança previsível, permitindo que nossos clientes escalem suas operações sem surpresas com custos de tecnologia. O Lupa Paranoá foi desenvolvido para empresas que desejam tomar decisões baseadas em dados, independentemente da sua natureza, apoiando a cultura data-driven em toda a organização.
</p>
              </p>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
               O Paranoá centraliza seus dados, seja qual for a fonte, organiza-os, qualifica-os e entrega os "dados de ouro" prontos para serem consumidos, impulsionando sua tomada de decisão e seus negócios.
              </p>
              <div className="mt-8">
                <a href="/contato" className="btn-primary">
                  Converse com um especialista
                </a>
              </div>
            </div>
            <div className="bg-gray-100 dark:bg-gray-800 p-8 rounded-xl shadow-lg">
              <h3 className="text-2xl font-bold text-lupa-purple dark:text-white mb-4">Benefícios Reais Para Seu Negócio</h3>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <svg className="h-6 w-6 text-lupa-orange mt-0.5 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-gray-700 dark:text-gray-300"><span className="font-semibold">Decisões mais rápidas e confiáveis:</span> Sua aplicação acessa os dados qualificados e confiáveis.</span>
                </li>
                <li className="flex items-start">
                  <svg className="h-6 w-6 text-lupa-orange mt-0.5 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-gray-700 dark:text-gray-300"><span className="font-semibold">Economia de tempo e recursos:</span> Automatize a coleta e organização de dados, liberando sua equipe para tarefas estratégicas.</span>
                </li>
                <li className="flex items-start">
                  <svg className="h-6 w-6 text-lupa-orange mt-0.5 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-gray-700 dark:text-gray-300"><span className="font-semibold">Jornada de IA:</span> potencialize suas aplicações de IA e ML com segurança, agilidade e escalabilidade acessando dados qualificados e em tempo real.</span>
                </li>
                <li className="flex items-start">
                  <svg className="h-6 w-6 text-lupa-orange mt-0.5 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-gray-700 dark:text-gray-300"><span className="font-semibold">Escalabilidade sem complicações:</span> Comece pequeno e cresça conforme sua necessidade, sem grandes investimentos iniciais.</span>
                </li>
                <li className="flex items-start">
                  <svg className="h-6 w-6 text-lupa-orange mt-0.5 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-gray-700 dark:text-gray-300"><span className="font-semibold">Democratização dos dados:</span> Permita que todos na empresa utilizem dados para melhorar seu trabalho, não apenas analistas.</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Como o Paranoá Transforma Seus Dados */}
          <div className="mt-20">
            <h2 className="text-3xl font-bold text-lupa-purple dark:text-white mb-8 text-center">Como o Paranoá Transforma Seus Dados</h2>
            <div className="relative">
              {/* Linha conectora */}
              <div className="hidden md:block absolute top-1/2 left-0 right-0 h-1 bg-gradient-to-r from-lupa-purple via-lupa-orange to-lupa-yellow transform -translate-y-1/2 z-0"></div>
              
              <div className="grid grid-cols-1 md:grid-cols-4 gap-8 relative z-10">
                <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg text-center">
                  <div className="w-16 h-16 mx-auto bg-lupa-purple rounded-full flex items-center justify-center mb-4">
                    <span className="text-2xl font-bold text-white">1</span>
                  </div>
                  <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-2">Coleta Inteligente</h3>
                  <p className="text-gray-700 dark:text-gray-300">
                    Conectamos todas as suas fontes de dados, desde planilhas e sistemas internos até aplicativos em nuvem, sem complicações técnicas.
                  </p>
                </div>
                <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg text-center">
                  <div className="w-16 h-16 mx-auto bg-lupa-orange rounded-full flex items-center justify-center mb-4">
                    <span className="text-2xl font-bold text-white">2</span>
                  </div>
                  <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-2">Organização Estruturada</h3>
                  <p className="text-gray-700 dark:text-gray-300">
                    Transformamos dados brutos em informações organizadas e acessíveis, criando uma única fonte confiável para toda a empresa.
                  </p>
                </div>
                <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg text-center">
                  <div className="w-16 h-16 mx-auto bg-lupa-yellow rounded-full flex items-center justify-center mb-4">
                    <span className="text-2xl font-bold text-white">3</span>
                  </div>
                  <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-2">Análise Simplificada</h3>
                  <p className="text-gray-700 dark:text-gray-300">
                    Oferecemos ferramentas intuitivas para que qualquer aplicação possa explorar dados, criar visualizações e descobrir insights valiosos.
                  </p>
                </div>
                <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg text-center">
                  <div className="w-16 h-16 mx-auto bg-lupa-purple-dark rounded-full flex items-center justify-center mb-4">
                    <span className="text-2xl font-bold text-white">4</span>
                  </div>
                  <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-2">Ação Estratégica</h3>
                  <p className="text-gray-700 dark:text-gray-300">
                    Transformamos insights em ações concretas, com alertas, recomendações e integrações que levam à melhoria contínua do negócio.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Tecnologia por Trás do Paranoá */}
          <div className="mt-20">
            <h2 className="text-3xl font-bold text-lupa-purple dark:text-white mb-8 text-center">A Tecnologia por Trás do Paranoá</h2>
            <div className="bg-white dark:bg-gray-800 p-8 rounded-xl shadow-lg">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div>
                  <h3 className="text-2xl font-bold text-lupa-purple dark:text-white mb-4">Arquitetura <Link to="/tecnologias/data-lakehouse" className="text-lupa-orange hover:underline">Data Lakehouse</Link></h3>
                  <p className="text-gray-700 dark:text-gray-300 mb-4">
                    O Lupa Paranoá é construído sobre uma moderna arquitetura Data Lakehouse, que combina o melhor dos Data Lakes (flexibilidade e baixo custo) com o melhor dos Data Warehouses (desempenho e confiabilidade).
                  </p>
                  <p className="text-gray-700 dark:text-gray-300 mb-4">
                    Esta abordagem permite que você armazene e processe qualquer tipo de dado (estruturado, semiestruturado ou não estruturado) em um único local, mantendo a performance necessária para análises em tempo real.
                  </p>
                  <ul className="space-y-2 mt-4">
                    <li className="flex items-center text-gray-700 dark:text-gray-300">
                      <svg className="h-5 w-5 text-lupa-orange mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4" />
                      </svg>
                      Armazenamento unificado para todos os tipos de dados
                    </li>
                    <li className="flex items-center text-gray-700 dark:text-gray-300">
                      <svg className="h-5 w-5 text-lupa-orange mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4" />
                      </svg>
                      Processamento otimizado para consultas rápidas
                    </li>
                    <li className="flex items-center text-gray-700 dark:text-gray-300">
                      <svg className="h-5 w-5 text-lupa-orange mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4" />
                      </svg>
                      Governança de dados integrada
                    </li>
                  </ul>
                </div>
                  <div>
                    <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-3">Governança e Segurança Integradas</h3>
                    <p className="text-gray-700 dark:text-gray-300 mb-4">
                      O Paranoá centraliza seus dados, organiza-os, qualifica-os e entrega os "dados de ouro" prontos para serem consumidos, impulsionando sua tomada de decisão e seus negócios.
                    </p>
                    <p className="text-gray-700 dark:text-gray-300 mb-4">
                      Nossa plataforma utiliza Governança de dados garantindo segurança, privacidade dos dados, mascaramento e linhagem de forma integrada e com políticas de segurança aplicadas em todos os níveis de acesso e processamento.
                    </p>
                    <p className="text-gray-700 dark:text-gray-300 mb-4">
                       Através da parceria com a Cloudera, garantimos uma solução eficiente e escalável com suporte de uma parceira multinacional, porém sem perder a capacidade de tecnologia aberta que permite flexibilidade e adaptação às necessidades específicas do seu negócio.
                    </p>
                  </div>
              </div>
            </div>
          </div>
          {/* Diferenciais da Plataforma Paranoá */}
<div className="mt-20">
  <h2 className="text-3xl font-bold text-lupa-purple dark:text-white mb-8 text-center">Diferenciais do Paranoá</h2>
  <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
    <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300">
      <div className="w-14 h-14 bg-lupa-orange rounded-full flex items-center justify-center mb-4">
        <svg className="h-7 w-7 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
        </svg>
      </div>
      <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-2">Governança Completa</h3>
      <p className="text-gray-700 dark:text-gray-300">
        Garantimos segurança, privacidade, mascaramento e linhagem de dados com políticas integradas que protegem suas informações em todos os estágios do processamento, mantendo conformidade com regulamentações como LGPD.
      </p>
    </div>
    <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300">
      <div className="w-14 h-14 bg-lupa-purple rounded-full flex items-center justify-center mb-4">
        <svg className="h-7 w-7 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
        </svg>
      </div>
      <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-2">Parceria Cloudera</h3>
      <p className="text-gray-700 dark:text-gray-300">
        Nossa aliança estratégica com a Cloudera garante uma infraestrutura empresarial robusta e escalável, com suporte técnico especializado e acesso às melhores práticas globais, sem abrir mão da flexibilidade de tecnologias abertas.
      </p>
    </div>
    <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300">
      <div className="w-14 h-14 bg-lupa-yellow rounded-full flex items-center justify-center mb-4">
        <svg className="h-7 w-7 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
      </div>
      <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-2">Dados de Ouro</h3>
      <p className="text-gray-700 dark:text-gray-300">
        Transformamos dados brutos em "dados de ouro" - informações de alta qualidade, confiáveis e prontas para consumo, que impulsionam decisões estratégicas e geram valor real para seu negócio com rapidez e precisão.
      </p>
    </div>
  </div>
</div>

{/* Casos de Uso */}
<div className="mt-20">
  <h2 className="text-3xl font-bold text-lupa-purple dark:text-white mb-8 text-center">Como o Paranoá Ajuda Empresas Como a Sua</h2>
  
  {/* Cards principais */}
  <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-10">
    <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg border-t-4 border-lupa-orange">
      <div className="w-16 h-16 bg-lupa-orange rounded-full flex items-center justify-center mb-4">
        <svg className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
        </svg>
      </div>
      <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-2">Varejo</h3>
      <p className="text-gray-700 dark:text-gray-300 mb-4">
        Unifique dados de vendas, estoque, marketing e comportamento do cliente para otimizar operações e melhorar a experiência do consumidor.
      </p>
      <ul className="space-y-2">
        <li className="flex items-center text-sm text-gray-600 dark:text-gray-400">
          <svg className="h-4 w-4 text-lupa-orange mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4" />
          </svg>
          Previsão de demanda mais precisa
        </li>
        <li className="flex items-center text-sm text-gray-600 dark:text-gray-400">
          <svg className="h-4 w-4 text-lupa-orange mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4" />
          </svg>
          Personalização de ofertas
        </li>
        <li className="flex items-center text-sm text-gray-600 dark:text-gray-400">
          <svg className="h-4 w-4 text-lupa-orange mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4" />
          </svg>
          Redução de rupturas de estoque
        </li>
      </ul>
    </div>
    <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg border-t-4 border-lupa-purple">
      <div className="w-16 h-16 bg-lupa-purple rounded-full flex items-center justify-center mb-4">
        <svg className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
        </svg>
      </div>
      <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-2">Indústria</h3>
      <p className="text-gray-700 dark:text-gray-300 mb-4">
        Integre dados de produção, qualidade, manutenção e cadeia de suprimentos para aumentar eficiência e reduzir custos operacionais.
      </p>
      <ul className="space-y-2">
        <li className="flex items-center text-sm text-gray-600 dark:text-gray-400">
          <svg className="h-4 w-4 text-lupa-orange mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4" />
          </svg>
          Manutenção preditiva
        </li>
        <li className="flex items-center text-sm text-gray-600 dark:text-gray-400">
          <svg className="h-4 w-4 text-lupa-orange mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4" />
          </svg>
          Otimização de processos produtivos
        </li>
        <li className="flex items-center text-sm text-gray-600 dark:text-gray-400">
          <svg className="h-4 w-4 text-lupa-orange mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4" />
          </svg>
          Controle de qualidade avançado
        </li>
      </ul>
    </div>
    <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg border-t-4 border-lupa-yellow">
      <div className="w-16 h-16 bg-lupa-yellow rounded-full flex items-center justify-center mb-4">
        <svg className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      </div>
      <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-2">Finanças</h3>
      <p className="text-gray-700 dark:text-gray-300 mb-4">
        Consolide dados financeiros, operacionais e de mercado para melhorar análises, previsões e gestão de riscos.
      </p>
      <ul className="space-y-2">
        <li className="flex items-center text-sm text-gray-600 dark:text-gray-400">
          <svg className="h-4 w-4 text-lupa-orange mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4" />
          </svg>
          Previsões financeiras mais precisas
        </li>
        <li className="flex items-center text-sm text-gray-600 dark:text-gray-400">
          <svg className="h-4 w-4 text-lupa-orange mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4" />
          </svg>
          Detecção de fraudes
        </li>
        <li className="flex items-center text-sm text-gray-600 dark:text-gray-400">
          <svg className="h-4 w-4 text-lupa-orange mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4" />
          </svg>
          Análise de rentabilidade por cliente/produto
        </li>
      </ul>
    </div>
  </div>
  
  {/* Cards secundários */}
  <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
    <div className="bg-gradient-to-br from-white to-gray-100 dark:from-gray-800 dark:to-gray-900 p-6 rounded-xl shadow-lg">
      <div className="flex items-center mb-4">
        <div className="w-12 h-12 bg-lupa-purple rounded-full flex items-center justify-center mr-4">
          <svg className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
          </svg>
        </div>
        <h3 className="text-xl font-bold text-lupa-purple dark:text-white">Setor Público</h3>
      </div>
      <p className="text-gray-700 dark:text-gray-300 mb-4">
        Transforme a gestão pública com análises de dados que otimizam recursos, aumentam a transparência e melhoram a prestação de serviços aos cidadãos.
      </p>
      <ul className="space-y-2">
        <li className="flex items-start">
          <svg className="h-5 w-5 text-lupa-orange mt-0.5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
          </svg>
          <span className="text-gray-700 dark:text-gray-300">Integração de dados entre diferentes órgãos</span>
        </li>
        <li className="flex items-start">
          <svg className="h-5 w-5 text-lupa-orange mt-0.5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
          </svg>
          <span className="text-gray-700 dark:text-gray-300">Monitoramento de indicadores de serviços</span>
        </li>
        <li className="flex items-start">
          <svg className="h-5 w-5 text-lupa-orange mt-0.5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
          </svg>
          <span className="text-gray-700 dark:text-gray-300">Otimização de recursos e redução de custos</span>
        </li>
      </ul>
    </div>
    
    <div className="bg-gradient-to-br from-white to-gray-100 dark:from-gray-800 dark:to-gray-900 p-6 rounded-xl shadow-lg">
      <div className="flex items-center mb-4">
        <div className="w-12 h-12 bg-lupa-yellow rounded-full flex items-center justify-center mr-4">
          <svg className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
          </svg>
        </div>
        <h3 className="text-xl font-bold text-lupa-purple dark:text-white">Saúde</h3>
      </div>
      <p className="text-gray-700 dark:text-gray-300 mb-4">
        Potencialize a gestão de saúde com uma plataforma que integra dados clínicos, administrativos e operacionais para decisões baseadas em evidências.
      </p>
      <ul className="space-y-2">
        <li className="flex items-start">
          <svg className="h-5 w-5 text-lupa-orange mt-0.5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
          </svg>
          <span className="text-gray-700 dark:text-gray-300">Integração de dados de sistemas de saúde</span>
        </li>
        <li className="flex items-start">
          <svg className="h-5 w-5 text-lupa-orange mt-0.5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
          </svg>
          <span className="text-gray-700 dark:text-gray-300">Análises preditivas para gestão de recursos</span>
        </li>
        <li className="flex items-start">
          <svg className="h-5 w-5 text-lupa-orange mt-0.5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
          </svg>
          <span className="text-gray-700 dark:text-gray-300">Dashboards para indicadores de saúde</span>
        </li>
      </ul>
    </div>
  </div>
</div>


          {/* Depoimentos 
          <div className="mt-20">
            <h2 className="text-3xl font-bold text-lupa-purple dark:text-white mb-8 text-center">O Que Nossos Clientes Dizem</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-lupa-orange rounded-full flex items-center justify-center mr-4">
                    <span className="text-xl font-bold text-white">PJ</span>
                  </div>
                  <div>
                    <h4 className="font-bold text-lupa-purple dark:text-white">Pitbull Jeans Brasil</h4>
                    <p className="text-sm text-gray-600 dark:text-gray-400">Varejo de Moda</p>
                  </div>
                </div>
                <p className="text-gray-700 dark:text-gray-300 italic">
                  "O Lupa Paranoá transformou a forma como utilizamos nossos dados. Antes, tínhamos informações espalhadas em vários sistemas e planilhas. Agora, conseguimos ver tudo em um só lugar e tomar decisões muito mais rápidas sobre estoque e campanhas de marketing."
                </p>
                <div className="mt-4 flex">
                  <svg className="h-5 w-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                  <svg className="h-5 w-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                  <svg className="h-5 w-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                  <svg className="h-5 w-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                  <svg className="h-5 w-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                </div>
              </div>
              <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-lupa-orange rounded-full flex items-center justify-center mr-4">
                    <span className="text-xl font-bold text-white">FC</span>
                  </div>
                  <div>
                    <h4 className="font-bold text-lupa-purple dark:text-white">Flavio Calçados</h4>
                    <p className="text-sm text-gray-600 dark:text-gray-400">Rede de Varejo</p>
                  </div>
                </div>
                <p className="text-gray-700 dark:text-gray-300 italic">
                  "A implementação do Paranoá nos permitiu economizar mais de 20 horas semanais que gastávamos compilando relatórios manualmente. Além disso, conseguimos identificar padrões de vendas que não víamos antes, o que nos ajudou a otimizar nosso mix de produtos em cada loja."
                </p>
                <div className="mt-4 flex">
                  <svg className="h-5 w-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                  <svg className="h-5 w-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                  <svg className="h-5 w-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                  <svg className="h-5 w-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                  <svg className="h-5 w-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
          */}
          {/* Integração com Outras Soluções */}
          <div className="mt-20">
            <h2 className="text-3xl font-bold text-lupa-purple dark:text-white mb-8 text-center">Potencialize Seus Dados com Nossas Soluções Integradas</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <Link to="/solucoes/lia" className="bg-white dark:bg-gray-800 p-8 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 border-2 border-transparent hover:border-lupa-orange group">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-lupa-purple rounded-full flex items-center justify-center mr-4">
                    <svg className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
                    </svg>
                  </div>
                  <h3 className="text-2xl font-bold text-lupa-purple dark:text-white group-hover:text-lupa-orange transition-colors duration-300">LIA - Lupa Inteligência Artificial</h3>
                </div>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  Combine o Paranoá com nossa solução de IA conversacional para permitir que qualquer pessoa na sua empresa faça perguntas complexas sobre os dados em linguagem natural e obtenha respostas imediatas.
                </p>
                <div className="mt-4 text-lupa-orange font-medium flex items-center">
                  Conheça a LIA
                  <svg className="ml-2 h-5 w-5 transform group-hover:translate-x-1 transition-transform duration-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </div>
              </Link>
              <Link to="/solucoes/lupa-cast" className="bg-white dark:bg-gray-800 p-8 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 border-2 border-transparent hover:border-lupa-orange group">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-lupa-orange rounded-full flex items-center justify-center mr-4">
                    <svg className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a1 1 0 011 1v9a2 2 0 01-2 2h-2a2 2 0 01-2-2zm6-6v-3a2 2 0 012-2h2a2 2 0 012 2v3m-6 0a2 2 0 012-2h2a2 2 0 012 2v6a2 2 0 01-2 2h-2a2 2 0 01-2-2v-6z" />
                    </svg>
                  </div>
                  <h3 className="text-2xl font-bold text-lupa-purple dark:text-white group-hover:text-lupa-orange transition-colors duration-300">Lupa Cast</h3>
                </div>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  Aproveite os dados organizados pelo Paranoá para fazer previsões precisas de vendas, demanda e tendências de mercado com nossa solução especializada em forecast.
                </p>
                <div className="mt-4 text-lupa-orange font-medium flex items-center">
                  Conheça o Lupa Cast
                  <svg className="ml-2 h-5 w-5 transform group-hover:translate-x-1 transition-transform duration-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </div>
              </Link>
            </div>
          </div>

          {/* Tecnologias Relacionadas */}
          <div className="mt-20">
            <h2 className="text-3xl font-bold text-lupa-purple dark:text-white mb-8 text-center">Tecnologias Relacionadas</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <Link to="/tecnologias/data-lakehouse" className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 border-2 border-transparent hover:border-lupa-orange group">
                <div className="w-16 h-16 bg-lupa-orange rounded-full flex items-center justify-center mb-4">
                  <svg className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-lupa-purple dark:text-white group-hover:text-lupa-orange transition-colors duration-300 mb-2">Data Lakehouse</h3>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  Entenda a arquitetura moderna que combina o melhor dos Data Lakes e Data Warehouses, base tecnológica do Lupa Paranoá.
                </p>
                <div className="text-lupa-orange font-medium flex items-center">
                  Saiba mais
                  <svg className="ml-2 h-5 w-5 transform group-hover:translate-x-1 transition-transform duration-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </div>
              </Link>
              <Link to="/tecnologias/big-data" className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 border-2 border-transparent hover:border-lupa-orange group">
                <div className="w-16 h-16 bg-lupa-orange rounded-full flex items-center justify-center mb-4">
                  <svg className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-lupa-purple dark:text-white group-hover:text-lupa-orange transition-colors duration-300 mb-2">Big Data</h3>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  Descubra como o Paranoá utiliza tecnologias de Big Data para processar grandes volumes de informações de forma eficiente.
                </p>
                <div className="text-lupa-orange font-medium flex items-center">
                  Saiba mais
                  <svg className="ml-2 h-5 w-5 transform group-hover:translate-x-1 transition-transform duration-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </div>
              </Link>
              <Link to="/tecnologias/ia" className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 border-2 border-transparent hover:border-lupa-orange group">
                <div className="w-16 h-16 bg-lupa-orange rounded-full flex items-center justify-center mb-4">
                  <svg className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-lupa-purple dark:text-white group-hover:text-lupa-orange transition-colors duration-300 mb-2">Inteligência Artificial</h3>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  Conheça como a IA pode potencializar os dados organizados pelo Paranoá, transformando-os em insights acionáveis.
                </p>
                <div className="text-lupa-orange font-medium flex items-center">
                  Saiba mais
                  <svg className="ml-2 h-5 w-5 transform group-hover:translate-x-1 transition-transform duration-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </div>
              </Link>
            </div>
          </div>
          {/* Call to Action Final */}
          <div className="mt-20 text-center bg-gradient-to-r from-lupa-purple to-lupa-purple-dark p-12 rounded-xl shadow-inner">
            <h2 className="text-3xl font-bold text-white mb-4">Transforme Seus Dados em Resultados Reais</h2>
            <p className="text-lg text-white/90 mb-8 max-w-2xl mx-auto">
              Descubra como o Lupa Paranoá pode ajudar sua empresa a entender melhor seus dados, economizar tempo em processos e tomar decisões mais inteligentes. Agende uma demonstração personalizada hoje mesmo.
            </p>
            <a href="/contato" className="bg-white text-lupa-purple hover:bg-gray-100 px-8 py-3 rounded-lg font-bold text-lg shadow-lg hover:shadow-xl transition-all duration-300">
              Solicite uma Demonstração
            </a>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default LupaParanoaPage;
